<template>
  <div id="preview">
    <div
      id="page-container"
      class="enable-page-overlay side-scroll main-content-boxed"
      style="padding-bottom: 50px"
    >
      <header-component></header-component>
      <sidebar-component></sidebar-component>
      <main id="main-container">
        <div class="btn-group absoluteAction" style="z-index: 100">
          <button
            v-if="this.status === 1"
            tag="button"
            type="button"
            class="btn btn-sm btn-success w-100"
            title="View"
            @click="submitandPublish"
          >
            <i class="fa fa-check-circle"></i>
            Submit
          </button>
        </div>
        <div class="content">
          <form @submit.prevent="sendForm" id="previewForm">
            <div class="row">
              <div class="col-12" v-if="isCreated">
                <ActionForm
                  :data="form.data"
                  :isValidSubmit="false"
                  :isValidSubmittedData="false"
                ></ActionForm>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
    <nav
      class="navbar navbar-light p-4 mt-4 w-100"
      style="background-color: #ffa400 !important; font-size: 16px"
    >
      <div class="container">
        <a href="/" class="navbar-brand text-dual"
          ><span class="font-w300 text-white">Copyright© 2020</span>
          <span class="font-w300 text-white">ARX</span></a
        >
      </div>
    </nav>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import formService from "../services/api/FormApi";
import ActionForm from "../views/ActionForm";
import HeaderComponent from "../components/layout/Header";
import SidebarComponent from "../components/layout/Sidebar";
import { LanguageMixin } from "./Mixins/LanguageMixin";
import { GetFormMixin } from "./Mixins/GetFormMixin";
import { SendFormMixin } from "./Mixins/SendFormMixin";
import $ from "jquery";

export default {
  name: "Preview",
  components: {
    ActionForm,
    HeaderComponent,
    SidebarComponent
  },
  mixins: [LanguageMixin, GetFormMixin, SendFormMixin],
  data() {
    return {
      status: 0,
      isCreated: false,
      notFound: false,
      notFoundErrorMessage: ""
    };
  },
  async created() {
    await this.getTranslate();
    this.getFormById({
      id: this.$route.params.id,
      type: "auth",
      isShow: false,
      isSubmitted: false
    }).then(response => {
      this.setBrowserLang(response.data.data.language);
      this.setLanguage();
      this.status = response.data.data.status;
      $(".tooltip").remove(); //TODO: why?
      this.setSuccessOrError(response); //TODO: is not worked, the endpoint not giving error message
    });
  },
  computed: {},
  methods: {
    ...mapActions({
      getFormById: "forms/getFormById",
      getTranslate: "translate/getTranslate"
    }),
    submitandPublish() {
      formService
        .postFormById({
          formData: { status: 2, action: "publish" },
          id: this.$route.params.id
        })
        .then(() => {
          this.$router.push({ name: "Dashboard" });
        });
    }
  }
};
</script>

<style scoped>
.absoluteAction {
  position: absolute;
  float: right;
  left: 2px;
  width: 110px;
  display: block;
  top: 111px;
}
</style>
